import React from 'react';
import { Languages } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

/**
 * LanguageSwitcher
 * Renders a small EN / AR toggle pill.
 * Only renders if Arabic is enabled at the company level.
 */
export default function LanguageSwitcher({ compact = false, dark = false }) {
  const { lang, setLang, arabicAvailable } = useLanguage();
  if (!arabicAvailable) return null;

  const handleClick = () => setLang(lang === 'en' ? 'ar' : 'en');

  if (compact) {
    return (
      <button
        type="button"
        data-testid="lang-switcher-compact"
        onClick={handleClick}
        title="Switch language / تبديل اللغة"
        className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-semibold border transition ${
          dark
            ? 'border-slate-700 text-slate-200 hover:border-amber-400 hover:text-amber-300'
            : 'border-slate-300 text-slate-700 hover:border-amber-500 hover:text-amber-700 bg-white'
        }`}
      >
        <Languages className="w-3.5 h-3.5" />
        {lang === 'en' ? 'AR' : 'EN'}
      </button>
    );
  }

  return (
    <div
      data-testid="lang-switcher"
      className={`inline-flex rounded-full p-0.5 border ${dark ? 'border-slate-700 bg-slate-800/40' : 'border-slate-300 bg-white'}`}
    >
      <button
        type="button"
        data-testid="lang-en-btn"
        onClick={() => setLang('en')}
        className={`px-3 py-1 rounded-full text-xs font-semibold transition ${
          lang === 'en'
            ? 'bg-amber-500 text-white'
            : dark ? 'text-slate-300' : 'text-slate-600'
        }`}
      >
        EN
      </button>
      <button
        type="button"
        data-testid="lang-ar-btn"
        onClick={() => setLang('ar')}
        className={`px-3 py-1 rounded-full text-xs font-semibold transition ${
          lang === 'ar'
            ? 'bg-amber-500 text-white'
            : dark ? 'text-slate-300' : 'text-slate-600'
        }`}
      >
        AR
      </button>
    </div>
  );
}
